import { render, staticRenderFns } from "./ViewOrganizationNews.vue?vue&type=template&id=b3fdbca4"
import script from "./ViewOrganizationNews.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationNews.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationNews.vue?vue&type=style&index=0&id=b3fdbca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports